import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ProductCardInfo from './ProductCardInfo'
import { Expand } from '../Icons'

import {
  ProductCardWrapper,
  ProductCardImage,
  ProductCardInfoWrapper,
  CardModalButton,
} from './ProductCard.style'

const ProductCard = ({
  brand,
  productBrandNameOverride,
  currency,
  description,
  image,
  locale,
  rrpPrice,
  salePrice,
  villagePrice,
  villageLevelLabels,
  onclickProductModal,
  selected,
  hasBackgroundHex,
}) => {
  const [screenWidth, setScreenWidth] = useState(null)

  useEffect(() => {
    setScreenWidth(window.innerWidth)
    window.addEventListener('resize', () => setScreenWidth(window.innerWidth))
    return () => {
      window.removeEventListener('resize', () =>
        setScreenWidth(window.innerWidth)
      )
    }
  }, [])

  return (
    <ProductCardWrapper onClick={onclickProductModal}>
      <CardModalButton>
        <Expand
          width={screenWidth > 600 ? 30 : 20}
          height={screenWidth > 600 ? 30 : 20}
        />
      </CardModalButton>
      <ProductCardImage
        image={image?.portrait?.gatsbyImageData}
        alt={image.altText}
        imgStyle={{
          maxHeight: 800,
        }}
        style={{
          maxHeight: 800,
        }}
      />
      <ProductCardInfoWrapper>
        <ProductCardInfo
          {...{
            brand,
            productBrandNameOverride,
            currency,
            description,
            locale,
            rrpPrice,
            salePrice,
            villagePrice,
            labels: villageLevelLabels,
            selected,
            hasBackgroundHex,
          }}
        />
      </ProductCardInfoWrapper>
    </ProductCardWrapper>
  )
}

ProductCard.propTypes = {
  brand: PropTypes.string.isRequired,
  productBrandNameOverride: PropTypes.string,
  currency: PropTypes.string,
  description: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string,
  rrpPrice: PropTypes.number,
  salePrice: PropTypes.number,
  villagePrice: PropTypes.number,
  villageLevelLabels: PropTypes.shape({}),
  onclickProductModal: PropTypes.func,
  selected: PropTypes.bool,
  hasBackgroundHex: PropTypes.bool,
}

ProductCard.defaultProps = {
  productBrandNameOverride: '',
  locale: 'en',
  salePrice: null,
  currency: null,
  rrpPrice: null,
  villagePrice: null,
  villageLevelLabels: {},
  onclickProductModal: () => {},
  selected: false,
  hasBackgroundHex: false,
}

export default ProductCard
